import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-supply-equipment',
  templateUrl: './manage-supply.component.html',
  styleUrls: ['./manage-supply.component.scss']
})
export class ManageSupplyComponent implements OnInit {
  
  isChecked:boolean = true;
  showCaseDetail: boolean = false;

  constructor() { }

  ngOnInit(): void {
  }

  openCaseDetail(){
    this.showCaseDetail = true;
  }
 
  getCloseCaseDetail(message){
    this.showCaseDetail = message;
  }

}
